const oauthLoginTemplate = `
 <pwr-oauth-login></pwr-oauth-login>
`;
export default oauthLoginTemplate;
